import React, { Component, Fragment } from 'react';
import {inject, observer} from "mobx-react";
import { Redirect } from 'react-router-dom';
import UnderHeader from "../../components/underHeader";

@inject('appStore')
@observer
export default class Rules extends Component{

    componentDidMount() {
        this.props.appStore.getRules();
    }

    componentWillUnmount() {
       this.props.appStore.clearRules();
    }

    render() {
        const {cashboxRules, cashboxMode} = this.props.appStore;

        if (cashboxMode != 2) return <Redirect to='/' />;

        return <Fragment>
            <div className="blue_line">
                <UnderHeader type={2} />
            </div>
            <div dangerouslySetInnerHTML={{__html: cashboxRules}}/>
        </Fragment>;
    }
}


// WEBPACK FOOTER //
// ./src/routes/rules/index.jsx